import React from "react";

import { Image, StyleSheet } from "@react-pdf/renderer";

import { MealKind } from "@/gql/graphql";
import AfternoonSnack from "@assets/icons/afternoon-snack-icon.png";
import Breakfast from "@assets/icons/breakfast-icon.png";
import Brunch from "@assets/icons/brunch-icon.png";
import Dinner from "@assets/icons/dinner-icon.png";
import Lunch from "@assets/icons/lunch-icon.png";
import MorningSnack from "@assets/icons/morning-snack-icon.png";
import PostWorkoutMeal from "@assets/icons/post-workout-meal-icon.png";
import PostWorkoutSnack from "@assets/icons/post-workout-snack-icon.png";
import PreWorkoutMeal from "@assets/icons/pre-workout-meal-icon.png";
import PreWorkoutSnack from "@assets/icons/pre-workout-snack-icon.png";
import Snack from "@assets/icons/snack-icon.png";
import Supper from "@assets/icons/supper-icon.png";

interface MealTypeIconPDFProps {
  mealType: MealKind;
}

const MealTypeIconPDF: React.FC<MealTypeIconPDFProps> = ({ mealType }) => {
  switch (mealType) {
    case MealKind.AfternoonSnack:
      return <Image src={AfternoonSnack} style={styles.icon} />;
    case MealKind.Breakfast:
      return <Image src={Breakfast} style={styles.icon} />;
    case MealKind.Brunch:
      return <Image src={Brunch} style={styles.icon} />;
    case MealKind.Dinner:
      return <Image src={Dinner} style={styles.icon} />;
    case MealKind.Lunch:
      return <Image src={Lunch} style={styles.icon} />;
    case MealKind.MorningSnack:
      return <Image src={MorningSnack} style={styles.icon} />;
    case MealKind.PostWorkoutMeal:
      return <Image src={PostWorkoutMeal} style={styles.icon} />;
    case MealKind.PostWorkoutSnack:
      return <Image src={PostWorkoutSnack} style={styles.icon} />;
    case MealKind.PreWorkoutMeal:
      return <Image src={PreWorkoutMeal} style={styles.icon} />;
    case MealKind.PreWorkoutSnack:
      return <Image src={PreWorkoutSnack} style={styles.icon} />;
    case MealKind.Snack:
      return <Image src={Snack} style={styles.icon} />;
    case MealKind.Supper:
      return <Image src={Supper} style={styles.icon} />;
    default:
      return <Image src={Breakfast} style={styles.icon} />;
  }
};

export default MealTypeIconPDF;

const styles = StyleSheet.create({
  icon: {
    height: 40,
    width: 40,
  },
});
